<template>
  <b-modal
    id="historicoProposta"
    ref="historicoProposta"
    hide-footer
    :no-enforce-focus="true"
    :title="label"
    @hidden="fechar()"
  >
    <div>
      <div
        v-for="historico in historicos"
        :key="historico.id"
        class="history-row mb-3 d-inline-flex"
      >
        <!-- <div class=""> -->
        <font-awesome-icon
          :icon="faHistory"
          class="text-primary mr-50"
          style="font-size:1.3rem !important;margin-top: 3px;"
        />
        <!-- </div> -->
        <div>
          <b>{{ historico.usuarioNome }}</b>
          &nbsp;{{ historico.conteudo }}
          <div
            class="detail mt-50"
            style="font-size: 12.5px;"
          ><b>{{ formatDate(historico.dataHora, { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute:'numeric' }) }}</b></div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHistory,
} from '@fortawesome/free-solid-svg-icons'
import { formatDate } from '@core/utils/filter'
import apiPortal from '@/app-modulo/comercial/portal-proposta/shared/services/api'
import apiProposta from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'HistoricoProposta',
  components: {
    FontAwesomeIcon,
  },
  props: {
    propostaId: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: 'Histórico da proposta',
    },
    tipoHistorico: {
      type: String,
      default: 'historico',
    },
    interno: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatDate,
      faHistory,
      historicos: null,
    }
  },
  created() {
    this.$nextTick(() => {
      this.show()
    })
  },
  methods: {
    show() {
      if (this.propostaId) {
        if (!this.interno) {
          if (this.tipoHistorico === 'tramite') {
            apiPortal.getTramites(this.propostaId)
              .then(payload => {
                this.historicos = payload.data
                this.$refs.historicoProposta.show()
              })
          } else if (this.tipoHistorico === 'visualizacao') {
            apiPortal.getVisualizacoes(this.propostaId)
              .then(payload => {
                this.historicos = payload.data
                this.$refs.historicoProposta.show()
              })
          } else {
            apiPortal.getHistoricos(this.propostaId)
              .then(payload => {
                this.historicos = payload.data
                this.$refs.historicoProposta.show()
              })
          }
        } else if (this.interno) {
          if (this.tipoHistorico === 'visualizacao') {
            apiProposta.getHistoricoVisualizacaoProposta(this.propostaId)
              .then(payload => {
                this.historicos = payload.data
                this.$refs.historicoProposta.show()
              })
          } else {
            apiProposta.getHistoricosProposta(this.propostaId)
              .then(payload => {
                this.historicos = payload.data
                this.$refs.historicoProposta.show()
              })
          }
        }
      }
    },
    fechar() {
      this.$emit('hidden')
    },
  },
}
</script>
